import http from '../plugins/axios'

export const getCustomMenuList = async (params) => {
  try {
    const response = await http.get(`/api/v2/custom-menus`, { params })
    return response.data
  } catch(error) {
    throw error
  }
}

export const addCustomMenu = async (payload) => {
  try {
    const response = await http.post(`/api/v2/custom-menus`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const updateCustomMenu = async (menuId, payload) => {
  try {
    const response = await http.put(`/api/v2/custom-menus/${menuId}`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const deleteCustomMenu = async (menuId) => {
  try {
    const response = await http.delete(`/api/v2/custom-menus/${menuId}`)
    return response.data
  } catch(error) {
    throw error
  }
}